module.exports = __webpack_public_path__ + "static/media/ellipsis.1ebd353c.svg";